import styled from '@emotion/styled'
import { CheckboxField } from 'view/components/inputs'

export const OrderSpreadsheetParseContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ReplaceExistingBondsCheckbox = styled(CheckboxField)`
  padding-top: 20px;
`
